import { useState, FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box } from '@mui/material'
import {
  Typography,
  TextField,
  PasswordField,
  Button,
  AuthenticationLayout
} from 'amo-styling-library'
import {
  TypographyVariant,
  ButtonSize,
  GlobalRadius,
  GlobalStateBasedOnStatus,
  Border
} from 'amo-styling-library'
import styled from 'styled-components'
import { useAuth } from '../contexts/AuthContext'
import '../styles/login-overrides.css'

const StyledBox = styled(Box)`
  display: flex;
  width: 30rem;
  min-width: 25rem;
  padding: 2rem;
  gap: 2rem;
  box-sizing: border-box;
  flex-direction: column;
  align-items: start;
  flex-shrink: 0;
  align-self: stretch;
  justify-content: space-between;
  border-radius: 1rem;
  background: white;
  box-shadow: 0.25rem 0 1.25rem 0 rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    width: 100%;
    height: 100vh;
    min-width: unset;
    padding: 1rem;
    overflow-y: auto;
    scrollbar-width: none;
  }
`

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
`

const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
`

const FullWidthWrapper = styled.div`
  width: 100%;

  & > div,
  & > div > div,
  & > div > div > div,
  & [class*="InputContainer"],
  & [class*="InputWrapper"],
  & [class*="InputElement"],
  & [class*="PasswordField"],
  & [class*="TextField"],
  & [class^="InputWrapper-sc-"],
  & [class^="InputContainer-sc-"],
  & input {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }
`

const LogoContainer = styled.div`
  width: 100%;
  height: 100px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: auto;
    height: 100%;
    object-fit: contain;
  }
`

function LoginPageNew() {
  const navigate = useNavigate()
  const { login: authLogin } = useAuth()
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setLoading(true)

    try {
      await authLogin(email, password)
      navigate('/start')
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Login failed'
      console.error('Login error:', errorMessage)
      alert(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthenticationLayout variant="default">
      <StyledBox component="form" onSubmit={handleSubmit}>
        <LogoContainer>
          <img
            src="/cropped-cropped-LOGO1-2.png"
            alt="LDH TRANS"
          />
        </LogoContainer>

        <FormContent>
          <Typography variant={TypographyVariant.H1} style={{ textAlign: 'center' }}>
            Login
          </Typography>

          <FieldsContainer>
            {/* Email Field - Primary border (red) */}
            <FullWidthWrapper>
              <TextField
                name="email"
                type="email"
                value={email}
                onChange={setEmail}
                label="Email"
                primaryBorder
                radius={GlobalRadius.ROUNDED}
              />
            </FullWidthWrapper>

            {/* Password Field with Forgot Password Link */}
            <FullWidthWrapper>
              <PasswordField
                name="password"
                value={password}
                onChange={setPassword}
                label="Wachtwoord"
                text={{
                  forgotPassword: 'Wachtwoord vergeten'
                }}
                onForgotPasswordClick={() => console.log('Forgot password clicked')}
                radius={GlobalRadius.ROUNDED}
              />
            </FullWidthWrapper>

            {/* Submit Button */}
            <Button
              type="submit"
              label={loading ? 'Inloggen...' : 'Inloggen'}
              size={ButtonSize.LARGE}
              radius={GlobalRadius.FULL}
              border={Border.FILLED}
              state={loading ? GlobalStateBasedOnStatus.LOADING : GlobalStateBasedOnStatus.REGULAR}
              disabled={loading}
              style={{ width: '100%' }}
            />
          </FieldsContainer>

          <Typography
            variant={TypographyVariant.TEXTLINK}
            onClick={() => navigate('/register')}
            style={{ cursor: 'pointer' }}
          >
            Nog geen account? Registreer hier.
          </Typography>
        </FormContent>
      </StyledBox>
    </AuthenticationLayout>
  )
}

export default LoginPageNew
